import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import instagram from '../images/Instagram_Glyph_Black.svg'

const FooterDiv = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 60px;
	padding:10px;
`;

const SocialMediaIcon = styled.img`
	height:40px !important;
`

class Footer extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
    }

	render() {
    	return (
            <div>
                <FooterDiv className="bg-light opacity90">
                    <div className="container">
						<div className="row">
							<div className="col-6 text-left">
								<a href="https://www.instagram.com/foerderverein_bongartzstift" target="_blank">
									<SocialMediaIcon src={instagram} className="img-fluid" />
								</a>
								<span> </span>
								<a href="https://www.instagram.com/foerderverein_bongartzstift" target="_blank">
									foerderverein_bongartzstift
								</a>
							</div>
							<div className="col-6 text-right">
								<Link to={"/impressum"}>Impressum</Link> <span> </span>
								<Link to={"/datenschutz"}>Datenschutz</Link>
							</div>
						</div>
					</div>
                </FooterDiv>
            </div>
    	);
  	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.component.js